import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Button } from "react-bootstrap";
import { LineoutTarget } from "../../models/enums/LineoutTarget";
import { FreekickOutcome } from "../../models/enums/FreekickOutcome";


const LineOutInfo = (props) => {
  const {
    isWon,
    setIsWon,
    lineoutTarget,
    setLineoutTarget,
    isFreekick,
    setIsFreekick,
  } = props;

  const handleWonOrLostStatus = (isWon) => {
    setIsWon(isWon);
  };

  const handleTargetToggle = (target) => {
    setLineoutTarget(target);
  };

  const isTargetActive = (targetStatus) => {
    return lineoutTarget === targetStatus;
  };

  const handleFreekickStatus = (status) => {
    setIsFreekick((prevState) => (prevState === status ? null : status));
  };

  return (
    <>
      <div className="col-md-12 text-center">
        <Row style={{ marginTop: "2rem" }}>
         
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-2.5rem"}}>
          <h5>Outcome</h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isWon ? "#70747c" : "",
                  color: isWon ? "white" : "",
                }}
                onClick={() => handleWonOrLostStatus(true)}
              >
                WON
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isWon === false ? "#70747c" : "",
                  color: isWon === false ? "white" : "",
                }}
                onClick={() => handleWonOrLostStatus(false)}
              >
                LOST
              </Button>
            </div>
          </Col>
         
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-2.5rem"}}>
          <h5>Target</h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Front)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Front) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Front)}
              >
                FRONT
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Middle)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Middle) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Middle)}
              >
                MIDDLE
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Back)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Back) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Back)}
              >
                BACK
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "100px",
                  height: "40px",
                  backgroundColor: isTargetActive(LineoutTarget.Midfield)
                    ? "#70747c"
                    : "",
                  color: isTargetActive(LineoutTarget.Midfield) ? "white" : "",
                }}
                onClick={() => handleTargetToggle(LineoutTarget.Midfield)}
              >
                MIDFIELD
              </Button>
            </div>
          </Col>
          <Col xs={4} className="flex-column align-items-center" style={{marginTop: "-1rem"}}>
          <h5></h5>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                    isFreekick === FreekickOutcome.FreeKickFor ? "#70747c" : "",
                  color:
                    isFreekick === FreekickOutcome.FreeKickFor ? "white" : "",
                }}
                onClick={() =>
                  handleFreekickStatus(FreekickOutcome.FreeKickFor)
                }
              >
                FREE KICK FOR
              </Button>
            </div>
            <div className="col-md-12 text-center mb-3">
              <Button
                className="fixed-size-button"
                variant="outline-secondary"
                style={{
                  width: "170px",
                  height: "40px",
                  backgroundColor:
                    isFreekick === FreekickOutcome.FreeKickAgainst
                      ? "#70747c"
                      : "",
                  color:
                    isFreekick === FreekickOutcome.FreeKickAgainst
                      ? "white"
                      : "",
                }}
                onClick={() =>
                  handleFreekickStatus(FreekickOutcome.FreeKickAgainst)
                }
              >
                FREE KICK AGAINST
              </Button>
            </div>
          </Col>
        </Row>
      </div>
       </>
  );
};

export default LineOutInfo;
